import PolicyLayout from "../components/PolicyLayout";

const sections = [
  {
    heading: "Our Commitment to You",
    paragraphs: [
      "We, at Finncube Credit Services Pvt. Ltd. (the 'Company'), consider customer service as a crucial aspect of our business growth and always strive to provide exceptional service to our customers.",
      "We understand that prompt and efficient service is necessary to establish and maintain customer relationships, and customer satisfaction is of utmost importance to us.",
      "We value customer complaints as they provide us with valuable feedback. To handle complaints efficiently, we have a structured grievance redressal framework supported by a review mechanism that helps us identify and resolve similar issues in the future.",
    ],
  },
  {
    heading: "Our Service Principles",
    items: [
      "Fair Treatment – Customers will always be treated fairly.",
      "Prompt Service – Complaints will be handled with courtesy and promptness.",
      "Clear Communication – Customers will be informed about escalation channels and their rights.",
      "Efficient Resolution – Complaints will be addressed efficiently and fairly.",
    ],
  },
  {
    heading: "How to Lodge a Complaint",
    paragraphs: [
      "Customers can approach any of the following service touch points for grievance, complaint, or feedback regarding the products and services offered by the Company.",
    ],
    items: [
      "Phone: +91 9017339057",
      "Email: care@finncube.com",
      "Address: 9th Floor, 954/AB, JMD Megapolis, Sohna Road, Gurugram, Haryana,122018",
    ],
  },
  {
    heading: "How a Complaint Should Be Made",
    paragraphs: [
      "Customers are requested to provide the following information when communicating their complaint or feedback.",
    ],
    items: [
      "Loan Details including Loan Account Number.",
      "Clear description of the complaint or feedback.",
      "Contact information including registered phone number and email address.",
    ],
  },
  {
    heading: "When to Expect the Reply",
    paragraphs: [
      "The Company will make every effort to respond to all queries and grievances within a reasonable time and keep customers informed about the status of their complaints.",
      "Since each customer query or complaint is unique, it may take up to 7 working days to resolve completely after investigation, provided all necessary information is received.",
    ],
  },
  {
    heading: "Whom to Approach for Redressal",
    paragraphs: [
      "Customers are requested to first raise their concerns through the channels mentioned above. If there is a delay or no response within the specified timelines, the complaint may be escalated to the Nodal Officer.",
    ],
    items: [
      "Name: Ritika",
      "Email: care@finncube.com",
      "Address: 9th Floor, 954/AB, JMD Megapolis, Sohna Road, Gurugram, Haryana,122018",
      "The Grievance Redressal Officer will attempt to resolve complaints within 5 days of receipt by email.",
    ],
  },
  {
    heading: "Resolution of Grievance",
    paragraphs: [
      "Our goal is to resolve complaints through official communication channels to the customer's satisfaction.",
      "We will provide alternate solutions wherever possible. If the customer remains dissatisfied, they may escalate the issue through the grievance redressal mechanism mentioned above.",
      "Suitable timelines have been set for every complaint depending upon the investigation required to resolve the issue.",
      "Complaints are acknowledged upon receipt and customers will be informed of delays, if any, in the resolution process.",
    ],
  },
];

function Grievance() {
  return (
    <PolicyLayout
      title="Grievance Redressal Policy"
      intro="To ensure that customer concerns are addressed and resolved in a timely manner, Finncube Credit Services Pvt. Ltd. has established the following grievance redressal framework."
      lastUpdated="March 10, 2026"
      sections={sections}
    />
  );
}

export default Grievance;
